<template>
  <div class="service-box">
    <div class="tit-fixed">
      <div class="jarallax-container">
        <div class="cst_container_base">
          <h1>关于我们</h1>
          <h2></h2>
          <h3>ABOUT US</h3>
        </div>
      </div>
      <div class="cst_textbox_line"></div>
    </div>
    
    <div class="list-wrap">
      <div class="zhanwei"></div>
      <div class="wrap">
        <div class="service_box">
          <el-tabs tab-position="left" v-model="modelShow" @tab-click="handleClick">
            <el-tab-pane label="公司介绍" name="9">
              <div class="smc_Area smc_Area3" v-html="newsData9"></div>
            </el-tab-pane>
            <el-tab-pane label="管理团队" name="10">
              <div class="smc_Area smc_Area3" v-html="newsData10"></div>
            </el-tab-pane>
            <el-tab-pane label="招贤纳士" name="11">
              <div class="smc_Area smc_Area3" v-html="newsData11"></div>
              
            </el-tab-pane>
            <el-tab-pane label="发展战略" name="12">
              <div class="smc_Area smc_Area3" v-html="newsData12"></div>
            </el-tab-pane>
            <el-tab-pane label="联系我们" name="5">
              <div class="smc_Area smc_Area4">
                <div class="smc_title">
                  <h1>联系我们</h1>
                  <p>联系电话：{{ newsData5.tel }}</p>
                  <p>营销中心：{{ newsData5.phone }}</p>
                  <!-- <p>公司传真：010-68944475</p> -->
                  <p>公司邮箱：{{ newsData5.email }}</p>
                  <p>公司地址：{{ newsData5.addr }}</p>
                </div>
                <div class="smartImg">
                  <img src="@/assets/image/55.jpg" alt="" />
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import News from '@/api/api.js'

export default {
  data() {
    return {
      isSticky: false, //是否吸顶
      modelShow: '9',//用来传选中值

      newsData9: '',
      newsData10: '',
      newsData11: '',
      newsData12: '',
      newsData5: '',
    };
  },
  created() {
    this.modelChange()
          // this.$watch('newsData9', this.addImgClass)
          // this.$watch('newsData10', this.addImgClass)
          // this.$watch('newsData11', this.addImgClass)
          // this.$watch('newsData12', this.addImgClass)
  },
  watch: {
    $route(to,from){
      this.modelChange()
    },
  },
  mounted() {
  },
  methods: {
    handleClick(tab, event) {
      this.$router.push('/AboutUsPage?model='+ tab.name);
    },
    modelChange() {
      this.modelShow = this.$route.query.model || '9'
      if(this['newsData'+this.modelShow]=='') {
        if(this.modelShow!=5) {
          this.$watch('newsData'+this.modelShow, this.addImgClass)

          this.getData(this.modelShow)
        }else{
          this.getContactInfo()
        }
      }
    },
    async getData(classId){
      this.searchDTO = {
        classId  //新闻分类
      };
      let res = await News.getNewList(this.searchDTO);
      this['newsData'+classId] = res.data[0].content;
    },
    async getContactInfo(){
      let res = await News.getUser();
      if (res.code===0){
        this.newsData5 = res.msg;
      } else {
        this.$message.error("获取联系方式失败")
      }
    },
  },
};
</script>

<style lang="scss"  scoped >
/deep/ .el-tabs__item {
  font-size: 16px;
  height: 50px;
  line-height: 50px;
}
/deep/ .el-tabs__item.is-active,
/deep/ .el-tabs__item:hover {
  color: #26a3de;
}
/deep/ .el-tabs__active-bar {
  background: #26a3de;
}
.service-box {
  position: relative;

  background: linear-gradient(rgba(28, 69, 135, 0.7), rgb(32, 18, 77)),
    url("../../assets/image/news_bg.jpg") center center / cover no-repeat;
    background-attachment: fixed;
  img {
    max-width: 100%;
  }
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px #99aeff;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    background: #99aeff;
  }
  &::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px #99aeff;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
.list-wrap {
  // margin-top: 85px;
  //   padding-bottom: 85px;
  //   padding-top: 0px;
  //   background-color: rgb(7, 55, 99);
  //   min-height: 20px;
  //   height: 100%;
  .service_box {
    width: var(--base-width);
    margin: 0 auto;
    color: #fff;
    padding: 50px 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    @media screen and (min-width: 300px) and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    /deep/ .el-tabs {
      width: 100%;
    }
    .tab {
      width: 100%;
      position: relative;
      display: flex;
    }
    .tab ul {
      width: 150px;
      height: 50px;
      display: flex;
      flex-direction: column;
      margin-right: 20px;
      li {
        width: 150px;
        display: flex;
        box-sizing: border-box;
        padding: 0;
        line-height: 50px;
        list-style: none;
        text-align: center;
        // background: rgba(153, 0, 255, 0.5);
        background: #fff;
        color: #000;
        cursor: pointer;
        h2 {
          font-size: 16px;
          text-align: center;
          flex: 1;
        }
        .left_line {
          width: 10px;
          height: 50px;
          background: #fff;
        }
      }
    }

    .tab ul li.active .left_line {
      width: 10px;
      height: 50px;
      background: rgba(79, 20, 119, 0.8);
    }

    // .smc_Area {

    // }
    .smc_Area0 {
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      line-height: 30px;
      color: #000;
      .smc_title {
        padding: auto;
        p {
          font-size: 16px;
          margin: 20px 0;
          text-indent: 2em;
        }
      }
      .smartImg0 {
        width: 60%;
        margin: 0 auto;
        img {
          width: 100%;
        }
      }
      .smartImg {
        width: 100%;
        img {
          width: 100%;
        }
      }
      span {
        text-align: center;
        display: block;
      }
    }
    .smc_Area1 {
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      line-height: 30px;
      color: #000;
      .smc_title {
        padding: auto;
        p {
          font-size: 16px;
          margin: 20px 0;
        }
      }
      .smartImg {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
    .smc_Area2 {
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      line-height: 30px;
      color: #000;
      .smc_title {
        padding: auto;
        h2 {
          color: #1a46a7;
          // text-align: center;
          line-height: 50px;
          padding-top: 20px;
        }
        p {
          font-size: 16px;
          margin: 10px 0;
        }
      }
      .smartImg {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
    .smc_Area3 {
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      line-height: 30px;
      color: #000;
      .smc_title {
        padding: auto;
        h2 {
          color: #1a46a7;
          text-align: center;
        }
        p {
          font-size: 16px;
          margin: 20px 0;
        }
      }
      .smartImg {
        width: 100%!important;
        img {
          width: 100%;
        }
      }
    }
    .smc_Area4 {
      flex: 1;
      display: flex;
      justify-content: space-between;
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      line-height: 30px;
      color: #000;
      .smc_title {
        width: 48%;
        h2 {
          font-weight: 700;
          color: #1a46a7;
          border-bottom: 1px solid #eee;
          padding-bottom: 30px;
        }
        p {
          font-size: 18px;
          line-height: 50px;
        }
        @media screen and (min-width: 300px) and (max-width: 768px) {
          width: 100%;
        }
      }
      .smartImg {
        width: 50%;
        img {
          width: 100%;
        }
        @media screen and (min-width: 300px) and (max-width: 768px) {
          display: none;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/webapp/AboutUsPage.vue